import Graph from "./graph";
import { getObjectFromVertex } from "./utils";

export default class UserCache {

    constructor(cache) {
        this.userCacheObj = Graph.fromObject(cache);
    }

    getCacheObj() {
        return this.userCacheObj;
    }

    getConnectedObjects(fromObjectId, toObjectType, relationship) {

        let connectedObjects = [];

        if (this.userCacheObj.hasVertex(fromObjectId)) {
            const outEdges = this.userCacheObj.outEdges(fromObjectId);
            if (outEdges) {
                const outEdgesArray = Array.from(outEdges);
                let filteredEdgesArray = [];
                if (relationship) {
                    filteredEdgesArray = [...outEdgesArray.filter(({ target, type }) => target.type === toObjectType && type === relationship)];
                } else {
                    filteredEdgesArray = [...outEdgesArray.filter(({ target, type }) => target.type === toObjectType)];
                }

                connectedObjects = filteredEdgesArray.map(edge => getObjectFromVertex(edge.target));

            }
        }
        return connectedObjects;
    }

    getAccountWorkspaceDataStats() {

        const orgDataMap = new Map();
        if (this.userCacheObj) {
            this.userCacheObj.vertices("Workspace").forEach((org) => {
                orgDataMap.set(org.id, {
                    totalTeams: org.props.stats.communities ? org.props.stats.communities : 0,
                    totalInitiatives: org.props.stats.initiatives ? org.props.stats.initiatives : 0,
                    totalPlayBooks: org.props.stats.playbooks ? org.props.stats.playbooks : 0,
                    totalContents: org.props.stats.content ? org.props.stats.content : 0,
                });
                /*
                if (this.userCacheObj.hasVertex(org.id)) {
                    const orgEdges = this.userCacheObj.outEdges(org.id);
                    if (orgEdges) {
                        const orgEdgesArray = Array.from(orgEdges);

                        const data = [...orgEdgesArray.filter(({ target, type }) => {
                            if (target.type === 'Team' && type === "owns") {
                                if (target.props.addOnMetaData && target.props.addOnMetaData.isOwner) {
                                    return true;
                                }
                                if (target.props.addOnMetaData && target.props.addOnMetaData.isIndirectOwner) {
                                    return true;
                                }
                                return false;
                            } else {
                                return false;
                            }
                        })];

                        const orgStats = {
                            totalTeams: [...orgEdgesArray.filter(({ target, type }) => {
                                if (target.type === 'Team' && type === "owns") {
                                    return target.props.addOnMetaData.isOwner || target.props.addOnMetaData.isIndirectOwner;
                                } else {
                                    return false;
                                }
                            })].length,
                            totalInitiatives: [...orgEdgesArray.filter(({ target }) => target.type === 'Initiative')].length,
                            totalPlayBooks: [...orgEdgesArray.filter(({ target }) => target.type === 'Playbook')].length,
                            totalContents: [...orgEdgesArray.filter(({ target }) => target.type === 'Content')].length
                        }
                        orgDataMap.set(org.id, orgStats);
                    }
                }
                */
            });
            
        }

        return orgDataMap;
    }

    getAccountUsers(accountId, query) {

        let userData = {};

        if (accountId && this.userCacheObj) {
            userData = {
                "CustomerAdmin": this.getConnectedObjects(accountId, "AccountUser", "customerAdmin"),
                "User": this.getConnectedObjects(accountId, "AccountUser", "user")
            }
        }

        userData.CustomerAdminTotal = userData.CustomerAdmin.length;
        userData.usersTotal = userData.User.length;
        return userData;

    }
}